import StatusDot from './StatusDot'

export * from './StatusDot'
export default StatusDot
